module.exports = __webpack_public_path__ + "img/cover2.0c9a63cc.jpg";